import React from 'react';

import { DateTimeFormatOptions, useFormatter } from 'next-intl';

type FormatDateProps = {
  /**
   * ISO 8601 date or timestamp (both unix and js timestamps are supported)
   */
  date: number | string;
  options?: DateTimeFormatOptions;
};

export const FormatDate = ({
  date,
  options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  },
}: FormatDateProps) => {
  const format = useFormatter();
  let _date = typeof date === 'number' && date.toString().length === 10 ? date * 1000 : date;
  const dateTime = new Date(date);
  return <>{format.dateTime(dateTime, options)}</>;
};
